import isNil from "lodash/isNil";

const shouldTriggerMention = ({
  cursor,
  text,
}: {
  cursor: number;
  text: string;
}): boolean => {
  const before = text.slice(0, cursor + 1);
  const prevCharIndex = -2;
  const prevChar = before.at(prevCharIndex);
  const currentChar = before.at(-1);

  return (
    currentChar === "@" && (before.length === 1 || /\s/.test(prevChar ?? ""))
  );
};

const extractMentionQuery = ({
  cursor,
  text,
}: {
  cursor: number;
  text: string;
}): null | string => {
  const match = new RegExp(/@(\w*)$/).exec(text.slice(0, cursor));
  if (isNil(match)) return null;
  return match[1];
};

export { extractMentionQuery, shouldTriggerMention };
